<template>
  <!-- MDH -->
    <div class="mdh">
        <cq-header headertext="KICK-START YOUR GAINS AT THE FREE MILLION DOLLAR HABITS DEMO"></cq-header>

        <cqtextimagesection direction = "L" :imagesrc="images.manan" :playVisible="true" :showPlayBtn="true" showImgText="MANAN SHOWS YOU HOW" showTLRBorder="true">
          
          <cq-paratext> Did you know that there are 65 steps involved in making a cup of tea? Every step missed has a consequence like it or not, some of your goals are not getting done because you miss some of those 65 steps, unknowingly! </cq-paratext>
          <cq-paratext> You can watch a movie or you can invest 3 hours with Manan Vasa where he will give you a <b class="red">LIVE DEMONSTRATION</b> of what will it take for you to translate Any-One-Personal-Goal into reality in a time-bound manner and discover what those missing steps were using his Proprietary </cq-paratext>
          <cq-paratext><b class="red"> 'Make It Happen Framework' &copy;. </b></cq-paratext>
          <cq-paratext> You also Gain to develop a whole new relationship with <b class="red">Time, Focus, Clarity &amp; Reality</b> that is critical to hit your goal.  </cq-paratext>
          <cq-paratext><b> TAKE THE FREE DEMO NOW! </b></cq-paratext>
          <cq-btn id="bookseat">BOOK YOUR SEAT</cq-btn>
          
        </cqtextimagesection>
    </div>
    <!-- End MDH -->
</template>

<script>
import CQHeader from '../../components/ui/CQHeader.vue'
import CQButton from '../../components/ui/CQButton.vue'
import CQPara from '../../components/ui/CQPara.vue'
import CQTextImageSection from '../../components/ui/CQTextImageSection.vue'

// Import Images
import manan from '../../assets/image/common/manan.png'
import playbtn from '../../assets/image/common/playbtn.png'

export default {
    components: {
        'cq-header' : CQHeader,
        'cq-btn' : CQButton,
        'cq-paratext' : CQPara,
        'cqtextimagesection': CQTextImageSection
    },
    data() {
        return {
            images: { 
                manan,
                playbtn
            }
        }
  }
}
</script>

<style scoped>
.mdh >>> .red{
  color: var(--primary-color);
}

.mdh >>> #bookseat{
  display: flex;
  justify-content: center;
  padding-bottom: 5px;
}

@media only screen and (max-width: 992px){
  .mdh >>> #manan-img{
    position: relative;
    top: 0;
    left: 0;
  }

  .mdh >>> #playbtn{
    width: 13% !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }

  .mdh >>> #showhow{
    position: absolute;
    bottom: 1%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }

  .mdh >>> .mdh1{
    padding: 10px !important;
  }

  .mdh >>> .display-none{
    display: none;
  }
  
}

/* Desktop View */
@media only screen and (min-width: 992px){
  .mdh >>> .grey{
    background-image: linear-gradient(var(--secondary-color)45%, #C7C8CA);
    margin-bottom: 20px;
  }

  .mdh >>> .mdh1{
    padding-left: 104.5px !important;
    padding-right: 30px !important;
    padding-top: 45px;
  }
  
  .mdh >>> .mdh2{
    padding-right: 0% !important;
  }
  
  .mdh >>> #manan-img{
    padding: 30px 0 0 30px !important;
  }
  
  .mdh >>> #playbtn{
    position: absolute;
    top: 270px;
    left: 320px; 
    width: 15% !important;
  }

  .mdh >>> #showhow{
    position: absolute;
    left: 210px;
    z-index: 9999;
    bottom: 0;
  }

  .mdh >>> .top-left-borders{
  border-left: 4px solid var(--primary-color);
  border-top: 4px solid var(--primary-color);
  width: 150px;
  height: 150px;
  position: absolute;
}
}

</style>